export const BACKEND_URL = window._env_.BACKEND_URL;